import { CachePayloadInterface } from "./interfaces/cache.payload-interface";
import { EntityInterface } from 'src/app/entities/interfaces/entity-interface';

export class BaseCachePayload implements CachePayloadInterface {
  constructor(
    protected _payload: EntityInterface[],
    protected _createdAt: Date = new Date()
  ) {}

  /** {@inheritDoc CachePayloadInterface.invalidate} */
  invalidate(): void {
    this._createdAt = new Date(0);
  }

  /**
   * Creates an instance of this class with emtpy payload.
   *
   * @returns {BaseCachePayload}
   */
  static createEmpty(): BaseCachePayload {
    return new BaseCachePayload([], new Date(0));
  }

  /**
   * Creates an instance of this class.
   *
   * @param {EntityInterface[]} payload payload
   *
   * @returns this
   */
  static create(payload: EntityInterface[]): BaseCachePayload {
    return new BaseCachePayload(payload);
  }

  get createdAt(): Date {
    return this._createdAt;
  }

  get payload(): EntityInterface[] {
    return this._payload;
  }
  set payload(entities: EntityInterface[]) {
    this._payload = entities;
  }

  /** {@inheritDoc CachePayloadInterface.valueOf} */
  valueOf(): number {
    return this._createdAt.getTime();
  }
}
